import React, { Component } from "react";
import Progress from "../Progress/Progress";
import CustomizeSearchProds from "../CustomizeSearchProds/CustomizeSearchProds";
import Payment from "../Payment/Payment";
import BackNext from "../BackNext/BackNext";
import "./Onboarding.css";

class Onboarding extends Component {
	// Onboarding screen after signup form
	render() {
		return (
			<div className="onboarding container">
				<Progress
					onboardingStep={this.props.onboardingStep}
					onboardingFlow={this.props.onboardingFlow}
				/>
				<div className="onboarding-flow-ui">
					{this.props.onboardingStep === 1 && (
						<CustomizeSearchProds
							searchProducts={this.props.searchProducts}
							addToOnboardingCart={this.props.addToOnboardingCart}
						/>
					)}
					{this.props.onboardingStep === 2 && (
						<Payment
							getSignUpProductTotal={this.props.getSignUpProductTotal}
							signUpParams={this.props.signUpParams}
							onToken={this.props.onToken}
						/>
					)}
				</div>
				<BackNext
					nextOnboarding={this.props.nextOnboarding}
					backOnboarding={this.props.backOnboarding}
					back={true}
					next={this.props.onboardingStep === 2 ? false : true}
				/>
			</div>
		);
	}
}

export default Onboarding;


// WEBPACK FOOTER //
// ./src/components/SignUp/Onboarding/Onboarding.js